exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-2666a8bb]{border:none;border-radius:8px}.card-header[data-v-2666a8bb]{border-bottom:none}", ""]);

// exports
